import { render, staticRenderFns } from "./ModifyPartenaires.vue?vue&type=template&id=bfa8a95a&scoped=true&"
import script from "./ModifyPartenaires.vue?vue&type=script&lang=ts&"
export * from "./ModifyPartenaires.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyPartenaires.vue?vue&type=style&index=0&id=bfa8a95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa8a95a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAlert,VBreadcrumbs,VBtn,VCol,VContainer,VIcon,VRow,VSpacer,VToolbar,VToolbarTitle})
